/* eslint-disable @reatom/unit-naming-rule */
import { atom } from '@reatom/framework'
import { match } from 'ts-pattern'

import { Array, Result } from '@blade/std-lib'
import {
  reatomWalletAsset,
  type WalletAssetModel,
  type WalletModel,
} from '@root/entities/wallet'
import { reatomDataTable } from '@root/shared/ui-kit'

import { walletAssetsTableColumns } from '../ui/wallet-assets-table/wallet-assets-table-columns'

import type { TableData } from '@root/shared/ui-kit'

export type WalletAssetsColumnId =
  | 'name'
  | 'address'
  | 'balance'
  | 'price'
  | 'marketCap'
export type WalletAssetsTableContext = { wallet: WalletModel }

export const reatomWalletAssetsTable = ({
  wallet,
}: {
  wallet: WalletModel
}) => {
  const paramsAtom = atom((ctx) => {
    const assets = ctx.spy(wallet.visibleAssets)
    return {
      assets,
    }
  }, 'paramsAtom')

  const model = reatomDataTable({
    name: 'wallet-assets-table',
    columns: walletAssetsTableColumns,
    paramsAtom,
    getId: ({ currencyAddress }) => currencyAddress,
    loadItems: async (ctx, { params: { assets }, sorting }) => {
      const cmp = match(sorting)
        .with({ sortColumn: 'balance' }, ({ sortDirection }) =>
          sortDirection === 'asc'
            ? reatomWalletAsset.cmpBalanceUsdAsc(ctx)
            : reatomWalletAsset.cmpBalanceUsdDesc(ctx),
        )
        .otherwise(() => undefined)

      const assetsSorted = cmp ? Array.sort(cmp)(assets) : assets

      const data: TableData<WalletAssetModel> = {
        data: assetsSorted,
        hasNext: false,
      }
      return Result.succeed(data)
    },
  })

  return model
}
